import { FC } from 'react';

import { TextLink } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';
import { OrderManagementWithItems } from '@sitecore/types/manual/be/OrderManagementWithItems';

import { buildNavigationHref } from '../../../utils/buildNavigationHref';
import { priceSimulationSteps } from '../../price-simulation/types/PriceSimulationSteps';

type Fields = OrderManagementWithItems['fields'];

const trackChangeClick = (trackEventBE: ReturnType<typeof useTracking>['trackEventBE'], changeType: string) => {
  trackEventBE('be_om_click_change', {
    data: {
      change_type: changeType,
    },
  });
};

export const ChangeProductLink: FC<{
  fields: Fields;
  priceSimulationId: string | undefined;
  orderId: string | undefined;
  changeType: string;
}> = ({ fields, priceSimulationId, orderId, changeType }) => {
  const href = buildNavigationHref(fields.navigation.priceSimulationLink.value.href, {
    queryParams: {
      priceSimulationId,
      orderId,
    },
    stepHash: priceSimulationSteps.priceSimulationResult,
  });

  const { trackEventBE } = useTracking();

  return (
    <TextLink
      color="textLowEmphasis"
      href={href}
      target={fields.navigation.priceSimulationLink.value.target}
      onClick={() => {
        trackChangeClick(trackEventBE, changeType);
      }}>
      {fields.selectedProductsStep.changeLink.value.text}
    </TextLink>
  );
};

export const ChangeServiceLink: FC<{
  fields: Fields;
  changeType: string;
  onClick: () => void;
}> = ({ fields, changeType, onClick }) => {
  const { trackEventBE } = useTracking();

  return (
    <TextLink
      color="textLowEmphasis"
      onClick={() => {
        trackChangeClick(trackEventBE, changeType);
        onClick();
      }}>
      {fields.selectedProductsStep.changeLink.value.text}
    </TextLink>
  );
};

export const RemoveProductLink: FC<{
  fields: Fields;
  onClick: () => void;
}> = ({ fields, onClick }) => (
  <TextLink color="textLowEmphasis" onClick={onClick}>
    {fields.selectedProductsStep.removeProductLink.value.text}
  </TextLink>
);

export const RemoveServiceLink: FC<{
  fields: Fields;
  onClick: () => void;
}> = ({ fields, onClick }) => (
  <TextLink color="textLowEmphasis" onClick={onClick}>
    {fields.selectedProductsStep.removeServiceLink.value.text}
  </TextLink>
);

export const RateCardLink: FC<{
  href: string;
  target?: string;
  text: string;
}> = ({ href, target, text }) => (
  <TextLink color="textLowEmphasis" href={href} target={target}>
    {text}
  </TextLink>
);
